import { createContext } from 'react';

const categoryProductOptionContext = createContext();

export default categoryProductOptionContext;
